/*
 * Accordion state for the "GLOON - FAQ" section.
 *
 * The open/close animation itself is pure CSS (grid-template-rows
 * transition on .faq-item__panel) — nothing here touches height or
 * timing. This script only manages state: toggling the open class,
 * keeping aria-expanded in sync, and closing the other items in the
 * same accordion group when one is opened (native <details> can do the
 * "only one open" part for free via the `name` attribute, but it can't
 * animate the open/close transition, which this design requires).
 */
document.querySelectorAll('[data-gloon-faq-group]').forEach(function (group) {
  var items = Array.prototype.slice.call(group.querySelectorAll('[data-gloon-faq-item]'));

  items.forEach(function (item) {
    var trigger = item.querySelector('[data-gloon-faq-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      items.forEach(function (otherItem) {
        var otherTrigger = otherItem.querySelector('[data-gloon-faq-trigger]');
        otherItem.classList.remove('is-open');
        if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
});
